const Searchform = () => {
	document.addEventListener('alpine:init', function () {
		// Search Form Component
		Alpine.data('searchForm', () => ({
			searchQuery: '',
			isExpanded: false,
			isFocused: false,

			init() {
				// Check if there's an initial search query
				const urlParams = new URLSearchParams(window.location.search);
				const query = urlParams.get('s');
				if (query) {
					this.searchQuery = query;
					this.isExpanded = true;
				}
			},

			expand() {
				this.isExpanded = true;
				this.$nextTick(() => {
					this.$refs.searchInput.focus();
				});
			},

			collapse() {
				if (this.searchQuery.trim() === '') {
					this.isExpanded = false;
				}
			},

			clear() {
				this.searchQuery = '';
				this.isExpanded = false;
				this.$refs.searchInput.blur();
			},

			onFocus() {
				this.isFocused = true;
				this.isExpanded = true;
			},

			onBlur() {
				this.isFocused = false;
				setTimeout(() => {
					this.collapse();
				}, 200);
			},

			onInput() {
				if (this.searchQuery.length > 0) {
					this.isExpanded = true;
				}
			}
		}));
	});
};

export default Searchform;
